var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboar-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Drafts")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.drafts))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Submitted")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.submitted))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Review")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.review))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Approved")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.approved))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Archived")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.archived))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-7" })
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "event-cards-container" },
          [
            _vm.events.length === 0
              ? _c("div", { staticClass: "text" }, [
                  _vm._v("No approved events")
                ])
              : _vm._l(_vm.events, function(event, index) {
                  return _c("EventCard", {
                    key: index,
                    attrs: {
                      isChangeOrder: _vm.isChangeOrder,
                      event: event,
                      isNoTrans: index % 3 == 2,
                      isFromClientDashboardView: true
                    }
                  })
                })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 dashboard" }, [
        _vm._v("dashboard\n      "),
        _c("div", { staticClass: "icon-information" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row margin-bottom-8px" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Plan")]),
        _vm._v(" "),
        _c("div", { staticClass: "event-status" }, [_vm._v("event status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "divider" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Manage")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "divider" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Sign ups")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 1")]),
        _vm._v(" "),
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 2")]),
        _vm._v(" "),
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 3")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f737d3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f737d3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/main/Dashboard.vue
// module id = 1947
// module chunks = 1